import type { GetStaticPaths, GetStaticProps } from "next"
import {
  type CategoryArchiveProps,
  getCategoryArchive,
} from "@/components/resources/data/archives"
import {
  ARCHIVE_CATEGORIES,
  isArchiveCategory,
} from "@/components/resources/data/markdown/categories"
import { SiteLayout } from "@/components/resources/layouts/site"
import { ResourceCategoryArchive } from "@/components/resources/templates/ResourceCategoryArchive"

const Archive = (props: CategoryArchiveProps) => (
  <ResourceCategoryArchive {...props} />
)

Archive.getLayout = SiteLayout

export default Archive

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: ARCHIVE_CATEGORIES.map((category) => ({ params: { category } })),
  fallback: false,
})

export const getStaticProps: GetStaticProps<
  CategoryArchiveProps,
  { category: string }
> = async ({ params }) => {
  const category = params?.category
  const props =
    category && isArchiveCategory(category)
      ? await getCategoryArchive(category, 1)
      : null
  return props ? { props, revalidate: 180 } : { notFound: true }
}
